import { QueryClient } from "@tanstack/react-query";

import { Media, MediaFilter, MediaListRes, MediaUploadResItem } from "../types/media";
import { get, post, postFormData } from "./fetch.core";
import axios from "axios";
import { getLoginToken } from "./login.core";
import { getShopId } from "./shop.core";

export async function uploadMedia(files: FileList, queryClient: QueryClient) {
  const formData = new FormData();

  for (const file of files) {
    formData.append("media", file);
  }

  const res = await postFormData<MediaUploadResItem[]>("/admin/media/upload", formData);

  queryClient.invalidateQueries({ queryKey: ["mediaList"] });
  return res.data;
}

export async function uploadImageByUrl(url: string) {
  const res = await post<Media>("/admin/media/uploadImageByUrl", { url: url });
  return res.data;
}

export async function deleteMedia(id: string) {
  const res = await post("/admin/media/delete", { id });
  return res.data;
}

export async function fetchMediaList({ pageSize, page, search }: MediaFilter) {
  const res = await get<MediaListRes>(
    `/admin/media/list?isLinkProducts=true&paging.size=${pageSize}&paging.page=${page}&search=${search ? search : ""}`
  );
  return res.data;
}

export async function getMediaById(id: string) {
  const res = await get<Media>(`/admin/media/get?id=${id}`);
  return res.data;
}

export async function getMediaListByIds(ids: string[]) {
  const res = await post<Media[]>("/admin/media/listByIds", {
    ids,
  });

  return res.data;
}

export async function importProductMedia(data: FileList, handleProgress: (progress: number) => void) {
  const bodyFormData = new FormData();
  for (let i = 0; i < data.length; i++) {
    const file = data.item(i);
    bodyFormData.append("media", file!);
  }

  const rst = await axios<{ media: Media; productIdFeature: any; productIdGallery: any }[]>({
    headers: {
      "Content-Type": "multipart/form-data",
      "x-access-token": getLoginToken(),
      "shop-id": getShopId(),
    },
    method: "POST",
    data: bodyFormData,
    url: "admin/media/upload",
    baseURL: process.env.NEXT_PUBLIC_URL_ROOT,
    onUploadProgress: (progress) => {
      const { loaded } = progress;
      handleProgress(loaded);
    },
  });

  return rst;
}

export async function importProductMediaSingle(dataFile: File, handleProgress: (progress: number) => void) {
  const bodyFormData = new FormData();
  bodyFormData.append("media", dataFile);

  const rst = await axios<{ media: Media; productIdFeature: any; productIdGallery: any }[]>({
    headers: {
      "Content-Type": "multipart/form-data",
      "x-access-token": getLoginToken(),
      "shop-id": getShopId(),
    },
    method: "POST",
    data: bodyFormData,
    url: "admin/media/upload",
    baseURL: process.env.NEXT_PUBLIC_URL_ROOT,
    onUploadProgress: (progress) => {
      const { loaded } = progress;

      console.log("loaded", loaded);
      handleProgress(loaded);
    },
  });

  return rst;
}

export function isVideo(media: Media | undefined) {
  if (!media) return false;

  const ext = media.filename.split(".").pop();
  if (!ext) return false;

  return ["mp4", "mov", "avi", "mkv", "webm", "flv", "wmv", "m4v", "m4a", "m4b", "m4p"].includes(ext);
}
